
import { Options, Vue } from "vue-class-component"; //基本需要\

import roma from "../assets/json1/roma.js";
import * as echarts from "echarts";
import passion1 from "@/assets/js/passion1.js";
import { store } from "@/store"; //引入仓库
import { ElMessage } from "element-plus";
import {
  dateConversion,
  getLocalProject,
  saveLocalProject,
  saveLocalStorageProject,
  typeConversion,
} from "@/utils"; //类型
import {
  dispatchGetSkinManagement,
  dispatchGetSkinLineView,
  dispatchUpdateSkinLineView,
  dispatchGetSkinLinePkg,
  dispatchGetSkinLineDate,
  dispatchAbdDateOptions,
  dispatchAbdDeviceptions,
  dispatchAbdSceneOptions,
  dispatchAbdSubtypeOptions,
  dispatchAbdList,
  dispatchAbdType,
  dispatchAbdProcess,
  dispatchAbdSum,
  dispatchAbdLog,
  dispatchAbdDateSingle,
  dispatchAbdCompare,
  dispatchAbdProcessCompare,
  dispatchAbdUrl,
  dispatchDeleteAbd,
} from "@/store/performance/actions";
// import God from "@/assets/js/god.js";
import {
  readGetSkinManagement,
  readGetSkinLineView,
  readGetSkinDate,
  readGetSkinPkg,
  readGetAbdDateOptions,
  readGetAbdDeviceOptions,
  readGetAbdSceneOptions,
  readGetAbdSubtypeOptions,
  readGetAbdList,
  readGetAbdType,
  readGetAbdProcess,
  readGetAbdSum,
  readGetAbdDateSingle,
  readGetAbdCompare,
  readGetAbdLog,
  readGetAbdProcessCompare,
  readGetAbdUrl,
} from "@/store/performance/getters";
export default class TestReport extends Vue {
  public localProject = Number(getLocalProject()); //得到本地的项目
  public b = "40%";
  public loading = false;
  public async mounted() {
    if (this.$route.query.date) {
      (this.filterList.date as any) = this.$route.query.date;
      (this.filterList.device as any) = Number(this.$route.query.device_id);
      (this.filterList.scene as any) = Number(this.$route.query.scene_id);
      (this.filterList.subtype as any) = Number(this.$route.query.subtype);
      (this.filterList.Journa as any) = Number(this.$route.query.id_test);

      await dispatchAbdDateOptions(store, {
        project: this.localProject,
      });
      // this.filterList.date = readGetAbdDateOptions(store)[0].date;
      await dispatchAbdDeviceptions(store, {
        project: this.localProject,
        date: this.filterList.date,
      });

      // this.filterList.device = readGetAbdDeviceOptions(store)[0].device_id;
      await dispatchAbdSceneOptions(store, {
        project: this.localProject,
        date: this.filterList.date,
        device_id: Number(this.filterList.device),
      });
      await this.sceneOptions;
      // this.filterList.scene = readGetAbdSceneOptions(store)[0].id;
      await dispatchAbdSubtypeOptions(store, {
        project: this.localProject,
        date: this.filterList.date,
        device_id: Number(this.filterList.device),
        scene_id: Number(this.filterList.scene),
      });

      // this.filterList.subtype = readGetAbdSubtypeOptions(store)[0].subtype;
      await dispatchAbdList(store, {
        project: this.localProject,
        date: this.filterList.date,
        device_id: Number(this.filterList.device),
        scene_id: Number(this.filterList.scene),
        subtype: Number(this.filterList.subtype),
      });

      // this.filterList.Journa = readGetAbdList(store)[0].id_test;
    } else {
      await dispatchAbdDateOptions(store, {
        project: this.localProject,
      });
      this.filterList.date = readGetAbdDateOptions(store)[0].date;
      await dispatchAbdDeviceptions(store, {
        project: this.localProject,
        date: this.filterList.date,
      });
      
      const option = readGetAbdDeviceOptions(store).find(item => item.name.includes('J200')) || readGetAbdDeviceOptions(store)[0]
      this.filterList.device = option?.device_id;

      await dispatchAbdSceneOptions(store, {
        project: this.localProject,
        date: this.filterList.date,
        device_id: Number(this.filterList.device),
      });
      this.filterList.scene = readGetAbdSceneOptions(store)[0].id;
      await dispatchAbdSubtypeOptions(store, {
        project: this.localProject,
        date: this.filterList.date,
        device_id: Number(this.filterList.device),
        scene_id: Number(this.filterList.scene),
      });
      this.filterList.subtype = readGetAbdSubtypeOptions(store)[0].subtype;
      await dispatchAbdList(store, {
        project: this.localProject,
        date: this.filterList.date,
        device_id: Number(this.filterList.device),
        scene_id: Number(this.filterList.scene),
        subtype: Number(this.filterList.subtype),
      });

      this.filterList.Journa = readGetAbdList(store)[0].id_test;

      this.$router.push({
        query: {
          ...this.$route.query,
          date: this.filterList.date,
          device_id: Number(this.filterList.device),
          scene_id: Number(this.filterList.scene),
          subtype: Number(this.filterList.subtype),
          id_test: Number(this.filterList.Journa),
        },
      });
    }

    await dispatchAbdType(store, {
      project: this.localProject,
      id_test: Number(this.filterList.Journa),
      search: this.record_input,
      size: this.record,
      page: this.currentPage1,
    });
    await dispatchAbdProcess(store, {
      project: this.localProject,
      id_test: Number(this.filterList.Journa),
      search: this.statistics_input,
      size: this.statistics,
      page: this.currentPage2,
    });
    await dispatchAbdDateSingle(store, {
      project: this.localProject,
      scene_id: Number(this.filterList.scene),
      device_id: Number(this.filterList.device),
      subtype: Number(this.filterList.subtype),
    });
    if (this.dateSingOptions.length <= 3) {
      this.dateSingOptions.forEach((v) => {
        this.filterList.dateSingle.push(v.date);
        this.filterList.processSingle.push(v.date);
      });
    } else {
      this.filterList.dateSingle.push(this.dateSingOptions[0].date);
      this.filterList.dateSingle.push(this.dateSingOptions[1].date);
      this.filterList.dateSingle.push(this.dateSingOptions[2].date);
      this.filterList.processSingle.push(this.dateSingOptions[0].date);
      this.filterList.processSingle.push(this.dateSingOptions[1].date);
      this.filterList.processSingle.push(this.dateSingOptions[2].date);
    }
    await dispatchAbdCompare(store, {
      project: this.localProject,
      id_test: Number(this.filterList.Journa),
      date_list: this.filterList.dateSingle,
      scene_id: Number(this.filterList.scene),
      device_id: Number(this.filterList.device),
      subtype: Number(this.filterList.subtype),
    });
    await dispatchAbdProcessCompare(store, {
      project: this.localProject,
      id_test: Number(this.filterList.Journa),
      date_list: this.filterList.processSingle,
      scene_id: Number(this.filterList.scene),
      device_id: Number(this.filterList.device),
      subtype: Number(this.filterList.subtype),
    });
    this.tableData = (this.abdCompare as any).list.slice(
      (this.currentPage3 - 1) * 10,
      this.currentPage3 * 10
    );
    this.tableProcessData = (this.abdProcessCompare as any).list.slice(
      (this.currentPage4 - 1) * 10,
      this.currentPage4 * 10
    );
    await dispatchAbdSum(store, {
      project: this.localProject,

      id_test: Number(this.filterList.Journa),
    });
    await dispatchAbdLog(store, {
      project: this.localProject,

      id_test: Number(this.filterList.Journa),
    });
    await dispatchAbdUrl(store, {
      project: this.localProject,

      id_test: Number(this.filterList.Journa),
    });
    await this.trendData;

    await this.drawTrend();
  }
  public get adbUrl() {
    return readGetAbdUrl(store);
  }
  public drawTrend() {
    let ordinates: any[] = [];
    this.trendEchart.params_list.forEach((v, index) => {
      ordinates.push({
        name: v,
        type: "line",
        data: this.trendEchart.series[index],
        smooth: true, // 平滑曲线
        symbol: "circle", //拐点设置为实心
        itemStyle: {
          normal: {
            label: {
              // show: this.getFPS_RawData.device_names.length <= 3 ? true : false,
              show: true,
            },
          },
        },
      });
    });
    let performance_line: any = document.getElementById("performance_line");
    echarts.dispose(performance_line);
    let PerformanceLineChart = echarts.init(performance_line);
    let option;
    option = {
      title: {
        left: "center",
        textStyle: {
          fontSize: 16,
          fontWeight: "normal",
        },
      },
      tooltip: {
        trigger: "axis",
      },
      legend: {
        x: "center",
        y: "bottom",
        type: "scroll",
        padding: [0, 0, 10, 0],
        // data: devices.map(
        //   (item) =>
        //     this.getDeviceSpecs.filter(
        //       (device) => device.id === item.device_id
        //     )[0]?.model.name
        // ),
      },
      grid: {
        left: "4%",
        top: "10%",
        bottom: "20%",
        right: "4%",
        containLabel: true,
      },

      animation: false,
      series: ordinates,
      yAxis: {
        type: "value",
      },
      xAxis: {
        type: "category",
        data: this.trendEchart.date,
      },
    };
    PerformanceLineChart.setOption(option);
  }

  public async allOption(type, check) {
    if (type == "date") {
      this.currentPage1 = 1;
      this.currentPage2 = 1;
      this.currentPage3 = 1;
      this.currentPage4 = 1;
      await dispatchAbdDeviceptions(store, {
        project: this.localProject,
        date: this.filterList.date,
      });
      
      const defaultOption = readGetAbdDeviceOptions(store).find(item => item.name.includes('J200')) || readGetAbdDeviceOptions(store)[0]
      this.filterList.device = defaultOption?.device_id;

      await dispatchAbdSceneOptions(store, {
        project: this.localProject,
        date: this.filterList.date,
        device_id: Number(this.filterList.device),
      });
      this.filterList.scene = readGetAbdSceneOptions(store)[0].id;
      await dispatchAbdSubtypeOptions(store, {
        project: this.localProject,
        date: this.filterList.date,
        device_id: Number(this.filterList.device),
        scene_id: Number(this.filterList.scene),
      });
      this.filterList.subtype = readGetAbdSubtypeOptions(store)[0].subtype;
      await dispatchAbdDateSingle(store, {
        project: this.localProject,
        scene_id: Number(this.filterList.scene),
        device_id: Number(this.filterList.device),
        subtype: Number(this.filterList.subtype),
      });
      this.filterList.dateSingle = [];
      this.filterList.processSingle = [];
      if (this.dateSingOptions.length <= 3) {
        this.dateSingOptions.forEach((v) => {
          this.filterList.dateSingle.push(v.date);
          this.filterList.processSingle.push(v.date);
        });
      } else {
        this.filterList.dateSingle.push(this.dateSingOptions[0].date);
        this.filterList.dateSingle.push(this.dateSingOptions[1].date);
        this.filterList.dateSingle.push(this.dateSingOptions[2].date);
        this.filterList.processSingle.push(this.dateSingOptions[0].date);
        this.filterList.processSingle.push(this.dateSingOptions[1].date);
        this.filterList.processSingle.push(this.dateSingOptions[2].date);
      }
      await dispatchAbdList(store, {
        project: this.localProject,
        date: this.filterList.date,
        device_id: Number(this.filterList.device),
        scene_id: Number(this.filterList.scene),
        subtype: Number(this.filterList.subtype),
      });
      this.filterList.Journa = readGetAbdList(store)[0].id_test;
      await dispatchAbdType(store, {
        project: this.localProject,
        id_test: Number(this.filterList.Journa),
        search: this.record_input,
        size: this.record,
        page: this.currentPage1,
      });
      await dispatchAbdProcess(store, {
        project: this.localProject,
        id_test: Number(this.filterList.Journa),
        search: this.statistics_input,
        size: this.statistics,
        page: this.currentPage2,
      });
      await dispatchAbdCompare(store, {
        project: this.localProject,
        id_test: Number(this.filterList.Journa),
        date_list: this.filterList.dateSingle,
        scene_id: Number(this.filterList.scene),
        device_id: Number(this.filterList.device),
        subtype: Number(this.filterList.subtype),
      });
      await dispatchAbdProcessCompare(store, {
        project: this.localProject,
        id_test: Number(this.filterList.Journa),
        date_list: this.filterList.dateSingle,
        scene_id: Number(this.filterList.scene),
        device_id: Number(this.filterList.device),
        subtype: Number(this.filterList.subtype),
      });
      this.tableData = (this.abdCompare as any).list.slice(
        (this.currentPage3 - 1) * 10,
        this.currentPage3 * 10
      );
      this.tableProcessData = (this.abdProcessCompare as any).list.slice(
        (this.currentPage4 - 1) * 10,
        this.currentPage4 * 10
      );
    }
    if (type == "device") {
      this.currentPage1 = 1;
      this.currentPage2 = 1;
      this.currentPage3 = 1;
      this.currentPage4 = 1;
      await dispatchAbdSceneOptions(store, {
        project: this.localProject,
        date: this.filterList.date,
        device_id: Number(this.filterList.device),
      });
      this.filterList.scene = readGetAbdSceneOptions(store)[0].id;
      await dispatchAbdSubtypeOptions(store, {
        project: this.localProject,
        date: this.filterList.date,
        device_id: Number(this.filterList.device),
        scene_id: Number(this.filterList.scene),
      });
      this.filterList.subtype = readGetAbdSubtypeOptions(store)[0].subtype;
      await dispatchAbdDateSingle(store, {
        project: this.localProject,
        scene_id: Number(this.filterList.scene),
        device_id: Number(this.filterList.device),
        subtype: Number(this.filterList.subtype),
      });
      this.filterList.dateSingle = [];
      this.filterList.processSingle = [];
      if (this.dateSingOptions.length <= 3) {
        this.dateSingOptions.forEach((v) => {
          this.filterList.dateSingle.push(v.date);
          this.filterList.processSingle.push(v.date);
        });
      } else {
        this.filterList.dateSingle.push(this.dateSingOptions[0].date);
        this.filterList.dateSingle.push(this.dateSingOptions[1].date);
        this.filterList.dateSingle.push(this.dateSingOptions[2].date);
        this.filterList.processSingle.push(this.dateSingOptions[0].date);
        this.filterList.processSingle.push(this.dateSingOptions[1].date);
        this.filterList.processSingle.push(this.dateSingOptions[2].date);
      }
      await dispatchAbdList(store, {
        project: this.localProject,
        date: this.filterList.date,
        device_id: Number(this.filterList.device),
        scene_id: Number(this.filterList.scene),
        subtype: Number(this.filterList.subtype),
      });
      this.filterList.Journa = readGetAbdList(store)[0].id_test;
      await dispatchAbdType(store, {
        project: this.localProject,
        id_test: Number(this.filterList.Journa),
        search: this.record_input,
        size: this.record,
        page: this.currentPage1,
      });
      await dispatchAbdProcess(store, {
        project: this.localProject,
        id_test: Number(this.filterList.Journa),
        search: this.statistics_input,
        size: this.statistics,
        page: this.currentPage2,
      });
      await dispatchAbdCompare(store, {
        project: this.localProject,
        id_test: Number(this.filterList.Journa),
        date_list: this.filterList.dateSingle,
        scene_id: Number(this.filterList.scene),
        device_id: Number(this.filterList.device),
        subtype: Number(this.filterList.subtype),
      });
      await dispatchAbdProcessCompare(store, {
        project: this.localProject,
        id_test: Number(this.filterList.Journa),
        date_list: this.filterList.dateSingle,
        scene_id: Number(this.filterList.scene),
        device_id: Number(this.filterList.device),
        subtype: Number(this.filterList.subtype),
      });
      this.tableData = (this.abdCompare as any).list.slice(
        (this.currentPage3 - 1) * 10,
        this.currentPage3 * 10
      );
      this.tableProcessData = (this.abdProcessCompare as any).list.slice(
        (this.currentPage4 - 1) * 10,
        this.currentPage4 * 10
      );
    }
    if (type === "scene") {
      this.currentPage1 = 1;
      this.currentPage2 = 1;
      this.currentPage3 = 1;
      this.currentPage4 = 1;
      await dispatchAbdSubtypeOptions(store, {
        project: this.localProject,
        date: this.filterList.date,
        device_id: Number(this.filterList.device),
        scene_id: Number(this.filterList.scene),
      });
      this.filterList.subtype = readGetAbdSubtypeOptions(store)[0].subtype;
      await dispatchAbdDateSingle(store, {
        project: this.localProject,
        scene_id: Number(this.filterList.scene),
        device_id: Number(this.filterList.device),
        subtype: Number(this.filterList.subtype),
      });
      this.filterList.dateSingle = [];
      this.filterList.processSingle = [];
      if (this.dateSingOptions.length <= 3) {
        this.dateSingOptions.forEach((v) => {
          this.filterList.dateSingle.push(v.date);
          this.filterList.processSingle.push(v.date);
        });
      } else {
        this.filterList.dateSingle.push(this.dateSingOptions[0].date);
        this.filterList.dateSingle.push(this.dateSingOptions[1].date);
        this.filterList.dateSingle.push(this.dateSingOptions[2].date);
        this.filterList.processSingle.push(this.dateSingOptions[0].date);
        this.filterList.processSingle.push(this.dateSingOptions[1].date);
        this.filterList.processSingle.push(this.dateSingOptions[2].date);
      }
      await dispatchAbdList(store, {
        project: this.localProject,
        date: this.filterList.date,
        device_id: Number(this.filterList.device),
        scene_id: Number(this.filterList.scene),
        subtype: Number(this.filterList.subtype),
      });
      this.filterList.Journa = readGetAbdList(store)[0].id_test;
      await dispatchAbdType(store, {
        project: this.localProject,
        id_test: Number(this.filterList.Journa),
        search: this.record_input,
        size: this.record,
        page: this.currentPage1,
      });
      await dispatchAbdProcess(store, {
        project: this.localProject,
        id_test: Number(this.filterList.Journa),
        search: this.statistics_input,
        size: this.statistics,
        page: this.currentPage2,
      });
      await dispatchAbdCompare(store, {
        project: this.localProject,
        id_test: Number(this.filterList.Journa),
        date_list: this.filterList.dateSingle,
        scene_id: Number(this.filterList.scene),
        device_id: Number(this.filterList.device),
        subtype: Number(this.filterList.subtype),
      });
      await dispatchAbdProcessCompare(store, {
        project: this.localProject,
        id_test: Number(this.filterList.Journa),
        date_list: this.filterList.dateSingle,
        scene_id: Number(this.filterList.scene),
        device_id: Number(this.filterList.device),
        subtype: Number(this.filterList.subtype),
      });
      this.tableData = (this.abdCompare as any).list.slice(
        (this.currentPage3 - 1) * 10,
        this.currentPage3 * 10
      );
      this.tableProcessData = (this.abdProcessCompare as any).list.slice(
        (this.currentPage4 - 1) * 10,
        this.currentPage4 * 10
      );
    }
    if (type == "subtype") {
      this.currentPage1 = 1;
      this.currentPage2 = 1;
      this.currentPage3 = 1;
      this.currentPage4 = 1;
      await dispatchAbdDateSingle(store, {
        project: this.localProject,
        scene_id: Number(this.filterList.scene),
        device_id: Number(this.filterList.device),
        subtype: Number(this.filterList.subtype),
      });
      this.filterList.dateSingle = [];
      this.filterList.processSingle = [];
      if (this.dateSingOptions.length <= 3) {
        this.dateSingOptions.forEach((v) => {
          this.filterList.dateSingle.push(v.date);
          this.filterList.processSingle.push(v.date);
        });
      } else {
        this.filterList.dateSingle.push(this.dateSingOptions[0].date);
        this.filterList.dateSingle.push(this.dateSingOptions[1].date);
        this.filterList.dateSingle.push(this.dateSingOptions[2].date);
        this.filterList.processSingle.push(this.dateSingOptions[0].date);
        this.filterList.processSingle.push(this.dateSingOptions[1].date);
        this.filterList.processSingle.push(this.dateSingOptions[2].date);
      }
      await dispatchAbdList(store, {
        project: this.localProject,
        date: this.filterList.date,
        device_id: Number(this.filterList.device),
        scene_id: Number(this.filterList.scene),
        subtype: Number(this.filterList.subtype),
      });
      this.filterList.Journa = readGetAbdList(store)[0].id_test;
      await dispatchAbdType(store, {
        project: this.localProject,
        id_test: Number(this.filterList.Journa),
        search: this.record_input,
        size: this.record,
        page: this.currentPage1,
      });
      await dispatchAbdProcess(store, {
        project: this.localProject,
        id_test: Number(this.filterList.Journa),
        search: this.statistics_input,
        size: this.statistics,
        page: this.currentPage2,
      });
      await dispatchAbdCompare(store, {
        project: this.localProject,
        id_test: Number(this.filterList.Journa),
        date_list: this.filterList.dateSingle,
        scene_id: Number(this.filterList.scene),
        device_id: Number(this.filterList.device),
        subtype: Number(this.filterList.subtype),
      });
      await dispatchAbdProcessCompare(store, {
        project: this.localProject,
        id_test: Number(this.filterList.Journa),
        date_list: this.filterList.dateSingle,
        scene_id: Number(this.filterList.scene),
        device_id: Number(this.filterList.device),
        subtype: Number(this.filterList.subtype),
      });
      this.tableData = (this.abdCompare as any).list.slice(
        (this.currentPage3 - 1) * 10,
        this.currentPage3 * 10
      );
      this.tableProcessData = (this.abdProcessCompare as any).list.slice(
        (this.currentPage4 - 1) * 10,
        this.currentPage4 * 10
      );
    }
    if (type === "Journa") {
      this.currentPage1 = 1;
      this.currentPage2 = 1;
      this.currentPage3 = 1;
      this.currentPage4 = 1;
      await dispatchAbdType(store, {
        project: this.localProject,
        id_test: Number(this.filterList.Journa),
        search: this.record_input,
        size: this.record,
        page: this.currentPage1,
      });
      await dispatchAbdProcess(store, {
        project: this.localProject,
        id_test: Number(this.filterList.Journa),
        search: this.statistics_input,
        size: this.statistics,
        page: this.currentPage2,
      });
      await dispatchAbdCompare(store, {
        project: this.localProject,
        id_test: Number(this.filterList.Journa),
        date_list: this.filterList.dateSingle,
        scene_id: Number(this.filterList.scene),
        device_id: Number(this.filterList.device),
        subtype: Number(this.filterList.subtype),
      });
      await dispatchAbdProcessCompare(store, {
        project: this.localProject,
        id_test: Number(this.filterList.Journa),
        date_list: this.filterList.dateSingle,
        scene_id: Number(this.filterList.scene),
        device_id: Number(this.filterList.device),
        subtype: Number(this.filterList.subtype),
      });
      this.tableData = (this.abdCompare as any).list.slice(
        (this.currentPage3 - 1) * 10,
        this.currentPage3 * 10
      );
      this.tableProcessData = (this.abdProcessCompare as any).list.slice(
        (this.currentPage4 - 1) * 10,
        this.currentPage4 * 10
      );
    }

    this.$router.push({
      query: {
        ...this.$route.query,
        date: this.filterList.date,
        device_id: Number(this.filterList.device),
        scene_id: Number(this.filterList.scene),
        subtype: Number(this.filterList.subtype),
        id_test: Number(this.filterList.Journa),
      },
    });
    // await dispatchAbdCompare(store, {
    //   project: this.localProject,
    //   id_test: Number(this.filterList.Journa),
    //   date_list: this.filterList.dateSingle,
    //   scene_id: Number(this.filterList.scene),
    //   device_id: Number(this.filterList.device),
    //   subtype: Number(this.filterList.subtype),
    // });
    // await dispatchAbdProcessCompare(store, {
    //   project: this.localProject,
    //   id_test: Number(this.filterList.Journa),
    //   date_list: this.filterList.dateSingle,
    //   scene_id: Number(this.filterList.scene),
    //   device_id: Number(this.filterList.device),
    //   subtype: Number(this.filterList.subtype),
    // });
    // this.tableData = (this.abdCompare as any).list.slice(
    //   (this.currentPage3 - 1) * 10,
    //   this.currentPage3 * 10
    // );
    // this.tableProcessData=(this.abdProcessCompare as any).list.slice(
    //   (this.currentPage4 - 1) * 10,
    //   this.currentPage4 * 10
    // );
    if (type === "dateSingle") {
      this.currentPage3 = 1;
      await dispatchAbdCompare(store, {
        project: this.localProject,
        id_test: Number(this.filterList.Journa),
        date_list: this.filterList.dateSingle,
        scene_id: Number(this.filterList.scene),
        device_id: Number(this.filterList.device),
        subtype: Number(this.filterList.subtype),
      });
      this.tableData = (this.abdCompare as any).list.slice(
        (this.currentPage3 - 1) * 10,
        this.currentPage3 * 10
      );
    }
    if (type === "processSingle") {
      this.currentPage4 = 1;
      await dispatchAbdProcessCompare(store, {
        project: this.localProject,
        id_test: Number(this.filterList.Journa),
        date_list: this.filterList.processSingle,
        scene_id: Number(this.filterList.scene),
        device_id: Number(this.filterList.device),
        subtype: Number(this.filterList.subtype),
      });
      this.tableProcessData = (this.abdProcessCompare as any).list.slice(
        (this.currentPage4 - 1) * 10,
        this.currentPage4 * 10
      );
    }
    if (check == true) {
      await dispatchAbdLog(store, {
        project: this.localProject,

        id_test: Number(this.filterList.Journa),
      });
      await dispatchAbdSum(store, {
        project: this.localProject,

        id_test: Number(this.filterList.Journa),
      });
      await dispatchAbdUrl(store, {
        project: this.localProject,

        id_test: Number(this.filterList.Journa),
      });
      await this.trendData;

      await this.drawTrend();
    }
  }
  public async recordSearch(page) {
    this.currentPage1 = 1;
    this.currentPage2 = 1;
    if (page === "statistics_input") {
      await dispatchAbdType(store, {
        project: this.localProject,
        id_test: Number(this.filterList.Journa),
        search: this.statistics_input,
        size: this.record,
        page: this.currentPage1,
      });
    } else {
      await dispatchAbdProcess(store, {
        project: this.localProject,
        id_test: Number(this.filterList.Journa),
        search: this.record_input,
        size: this.statistics,
        page: this.currentPage2,
      });
    }
  }
  public async handleCurrentChange(page: any) {
    if (page === "statistics_input") {
      await dispatchAbdType(store, {
        project: this.localProject,
        id_test: Number(this.filterList.Journa),
        search: this.statistics_input,
        size: this.record,
        page: this.currentPage1,
      });
    }
    if (page === "tableProcessData") {
      this.tableProcessData = (this.abdProcessCompare as any).list.slice(
        (this.currentPage4 - 1) * 10,
        this.currentPage4 * 10
      );
    }
    if (page === "tableData") {
      this.tableData = (this.abdCompare as any).list.slice(
        (this.currentPage3 - 1) * 10,
        this.currentPage3 * 10
      );
    } else if (page === "record_input") {
      await dispatchAbdProcess(store, {
        project: this.localProject,
        id_test: Number(this.filterList.Journa),
        search: this.record_input,
        size: this.statistics,
        page: this.currentPage2,
      });
    }
  }
  public async deleteBtn() {
    this.loading = true;
    this.currentPage1 = 1;
    this.currentPage2 = 1;
    this.currentPage3 = 1;
    this.currentPage4 = 1;
    await dispatchDeleteAbd(store, {
      project: this.localProject,
      id_test: Number(this.filterList.Journa),
    });
    await dispatchAbdDateOptions(store, {
      project: this.localProject,
    });
    this.filterList.date = readGetAbdDateOptions(store)[0].date;
    await dispatchAbdDeviceptions(store, {
      project: this.localProject,
      date: this.filterList.date,
    });
    this.filterList.device = readGetAbdDeviceOptions(store)[0].device_id;
    await dispatchAbdSceneOptions(store, {
      project: this.localProject,
      date: this.filterList.date,
      device_id: Number(this.filterList.device),
    });
    this.filterList.scene = readGetAbdSceneOptions(store)[0].id;
    await dispatchAbdSubtypeOptions(store, {
      project: this.localProject,
      date: this.filterList.date,
      device_id: Number(this.filterList.device),
      scene_id: Number(this.filterList.scene),
    });
    this.filterList.subtype = readGetAbdSubtypeOptions(store)[0].subtype;
    await dispatchAbdList(store, {
      project: this.localProject,
      date: this.filterList.date,
      device_id: Number(this.filterList.device),
      scene_id: Number(this.filterList.scene),
      subtype: Number(this.filterList.subtype),
    });

    this.filterList.Journa = readGetAbdList(store)[0].id_test;

    this.$router.push({
      query: {
        ...this.$route.query,
        date: this.filterList.date,
        device_id: Number(this.filterList.device),
        scene_id: Number(this.filterList.scene),
        subtype: Number(this.filterList.subtype),
        id_test: Number(this.filterList.Journa),
      },
    });
    await dispatchAbdType(store, {
      project: this.localProject,
      id_test: Number(this.filterList.Journa),
      search: this.record_input,
      size: this.record,
      page: this.currentPage1,
    });
    await dispatchAbdProcess(store, {
      project: this.localProject,
      id_test: Number(this.filterList.Journa),
      search: this.statistics_input,
      size: this.statistics,
      page: this.currentPage2,
    });
    await dispatchAbdDateSingle(store, {
      project: this.localProject,
      scene_id: Number(this.filterList.scene),
      device_id: Number(this.filterList.device),
      subtype: Number(this.filterList.subtype),
    });
    this.filterList.dateSingle = [];
    this.filterList.processSingle = [];
    if (this.dateSingOptions.length <= 3) {
      this.dateSingOptions.forEach((v) => {
        this.filterList.dateSingle.push(v.date);
        this.filterList.processSingle.push(v.date);
      });
    } else {
      this.filterList.dateSingle.push(this.dateSingOptions[0].date);
      this.filterList.dateSingle.push(this.dateSingOptions[1].date);
      this.filterList.dateSingle.push(this.dateSingOptions[2].date);
      this.filterList.processSingle.push(this.dateSingOptions[0].date);
      this.filterList.processSingle.push(this.dateSingOptions[1].date);
      this.filterList.processSingle.push(this.dateSingOptions[2].date);
    }
    await dispatchAbdCompare(store, {
      project: this.localProject,
      id_test: Number(this.filterList.Journa),
      date_list: this.filterList.dateSingle,
      scene_id: Number(this.filterList.scene),
      device_id: Number(this.filterList.device),
      subtype: Number(this.filterList.subtype),
    });
    await dispatchAbdProcessCompare(store, {
      project: this.localProject,
      id_test: Number(this.filterList.Journa),
      date_list: this.filterList.processSingle,
      scene_id: Number(this.filterList.scene),
      device_id: Number(this.filterList.device),
      subtype: Number(this.filterList.subtype),
    });
    this.tableData = (this.abdCompare as any).list.slice(
      (this.currentPage3 - 1) * 10,
      this.currentPage3 * 10
    );
    this.tableProcessData = (this.abdProcessCompare as any).list.slice(
      (this.currentPage4 - 1) * 10,
      this.currentPage4 * 10
    );
    await dispatchAbdSum(store, {
      project: this.localProject,

      id_test: Number(this.filterList.Journa),
    });
    await dispatchAbdLog(store, {
      project: this.localProject,

      id_test: Number(this.filterList.Journa),
    });
    await dispatchAbdUrl(store, {
      project: this.localProject,

      id_test: Number(this.filterList.Journa),
    });
    await this.trendData;

    await this.drawTrend();
    this.loading = false;
  }
  public get abdCompare() {
    return readGetAbdCompare(store);
  }
  public get abdProcessCompare() {
    return readGetAbdProcessCompare(store);
  }
  public get dateOptions() {
    return readGetAbdDateOptions(store);
  }
  public get dateSingOptions() {
    return readGetAbdDateSingle(store);
  }
  public get deviceOptions() {
    return readGetAbdDeviceOptions(store);
  }
  public get sceneOptions() {
    return readGetAbdSceneOptions(store);
  }
  public get subtypeOptions() {
    return readGetAbdSubtypeOptions(store);
  }
  public get JournaOptions() {
    return readGetAbdList(store);
  }
  public get getMonitorList() {
    return readGetAbdType(store);
  }
  public get getMonitorList1() {
    return readGetAbdProcess(store);
  }
  public get adbLog() {
    return readGetAbdLog(store);
  }
  public list = {};
  public get trendData() {
    this.trendList.forEach((v: any) => {
      v.data = readGetAbdSum(store).abd_info[v.value];
    });

    return this.trendList;
  }
  public get trend() {
    return readGetAbdSum(store);
  }
  public get trendEchart() {
    return readGetAbdSum(store).trend_data;
  }
  public statistics_input = ""; //统计搜索
  public packageBtn() {
    if (this.adbUrl === "") {
      ElMessage.error("无对应的流水线");
    } else {
      window.open(this.adbUrl, "_blank");
    }
  }
  public record = 10; //记录条数
  public statistics = 10; //统计条数
  public record_input = ""; //记录搜索
  public currentPage1 = 1;
  public currentPage2 = 1;
  public currentPage3 = 1;
  public currentPage4 = 1;
  public tableData = [];
  public tableProcessData = [];
  public trendList = [
    { name: "总日志数", value: "log_num" },
    { name: "主线程日志", value: "IL2CPP" },
    { name: "Crash日志", value: "CrashSightReport" },
    { name: "自动测试框架进程", value: "UIAutomator" },
    { name: "libEGL", value: "libEGL" },
    { name: "安卓服务进程", value: "BatteryService" },
    { name: "安卓监控系统", value: "KeyguardUpdateMonitor" },
    { name: "mali窗口系统", value: "mali_winsys" },
  ];
  public filterList = {
    date: "",
    device: "",
    scene: "",
    subtype: "",
    Journa: "",
    dateSingle: [],
    processSingle: [],
  };
  public btn(r, i) {
    let input: any = document.getElementById("input");
    (input as any).value = r.content;
    input.select();
    document.execCommand("copy");
    ElMessage({
      showClose: true,
      message: "当前信息已复制",
      type: "success",
    });
  }
}
